import { createFileRoute, useNavigate } from "@tanstack/react-router"
import { AixContentHeader } from "@aix/ui"
import { useEffect } from "react"
import CustomHead from "~/components/SEOHead/CustomHead"
import { SuperAdminLayout } from "~/layouts/SuperAdminLayout"

const SuperAdminPage = () => {
  const navigate = useNavigate()

  useEffect(() => {
    void navigate({ to: "/admin/teams", replace: true })
  }, [])
  return (
    <>
      <CustomHead />

      <AixContentHeader title="Super Admin" backUrl="/home" />
    </>
  )
}

function SuperAdminPageWrapper() {
  return (
    <SuperAdminLayout>
      <SuperAdminPage />
    </SuperAdminLayout>
  )
}

export const Route = createFileRoute("/admin/")({
  component: SuperAdminPageWrapper,
})
